import * as actions from 'actions';
import byIdMaker from 'reducersMakers/byIdMaker';

export default byIdMaker({
  fetchSuccessTypes: [
    actions.CHAT_WEBSITES_RECEIVED
  ],
  entityType: 'chatWebsites'
});



/** WEBPACK FOOTER **
 ** ./src/members/state/chat/chatWebsites/byId/reducer.js
 **/